import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import { Transition, Responsive } from "semantic-ui-react";
import API from "./API/API";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import {
  setIDCheck,
  setPages,
  setDevelopments,
  setDevelopmentProperties
} from "./redux/actions";
import Splash from "./components/Splash";
import LandingPage from "./pages/LandingPage";
import IDFromURLStart from "./components/IDFromURLStart";

class Navigator extends Component {
  constructor(props) {
    super(props);
    this.id = [];
  }
  state = { activeItem: "INICIO", mobileMenuVisible: false };

  componentWillMount() {
    const api = new API();
    api.getDevelopments("Dream Lagoons").then(responseDevelopments => {
      this.props.setDevelopments(responseDevelopments[0].developments);
    });
    api
      .getDevelopmentsProperties("Dream Lagoons")
      .then(responseDevelopmentProperties => {
        this.props.setDevelopmentProperties(
          responseDevelopmentProperties[0].developmentProperties
        );
      });
    api.getData("Dream Lagoons").then(responseData => {
      this.props.setPages(responseData[0].pages);
    });
  }

  renderPages() {
    if (this.state.mobileMenuVisible === false) {
      return (
        <div>
          <Switch>
            {this.props.developments.map((development, index) => {
              return (
                <Route key={index} path={"/" + development.url.trim()}>
                  <LandingPage url={development.url} />
                </Route>
              );
            })}

            <Route path="/" exact>
              <Splash items={this.props.developments} />
            </Route>
          </Switch>
          {/* <Footer /> */}
        </div>
      );
    }
  }

  renderInDesktop() {
    return <div>{this.renderPages()}</div>;
  }

  renderInMobile() {
    return (
      <div>
        <Transition
          visible={this.state.mobileMenuVisible}
          animation="fade"
          duration={300}
        >
          <div
            style={{
              height: "100%",
              width: "100%"
            }}
          >
            <div
              style={{
                backgroundColor: "black"
              }}
              className="menum"
              align="center"
            />
          </div>
        </Transition>
        {this.renderPages()}
      </div>
    );
  }

  renderInTablet() {
    return (
      <div>
        <Transition
          visible={this.state.mobileMenuVisible}
          animation="fade"
          duration={300}
        >
          <div className="menum" align="center" />
        </Transition>
        {this.renderPages()}
      </div>
    );
  }

  render() {
    return (
      <IDFromURLStart
        idsCheck={[
          { key: "referido", value: 0 },
          { key: "gclid", value: 0 },
          { key: "fbclid", value: 0 }
        ]}
        onGetIDCheck={idcheck => {
          this.props.setIDCheck(idcheck);
        }}
      >
        <Responsive {...Responsive.onlyMobile}>
          {this.renderInMobile()}
        </Responsive>
        <Responsive {...Responsive.onlyTablet}>
          {this.renderInTablet()}
        </Responsive>
        <Responsive {...Responsive.onlyComputer}>
          {this.renderInDesktop()}
        </Responsive>
      </IDFromURLStart>
    );
  }
}

const mapStateToProps = ({ state, data }) => {
  const { developments } = data;
  return {
    state,
    developments
  };
};

const mapDispatchProps = dispatch => {
  return {
    setPages: pages => {
      dispatch(setPages(pages));
    },
    setIDCheck: idcheck => {
      dispatch(setIDCheck(idcheck));
    },
    setDevelopments: developments => {
      dispatch(setDevelopments(developments));
    },
    setDevelopmentProperties: developmentProperties => {
      dispatch(setDevelopmentProperties(developmentProperties));
    }
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchProps
  )(Navigator)
);
